var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.buttonSizeClassName, _vm.buttonStyleClassName],attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onClickBtn()}}},[_vm._t("default"),_vm._v(_vm._s(_vm.text))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }